"use strict";

exports.__esModule = true;
exports.default = void 0;

var _breadcrumb = _interopRequireDefault(require("./breadcrumb"));

var _breadcrumbItem = _interopRequireDefault(require("./breadcrumb-item"));

var _breadcrumbLink = _interopRequireDefault(require("./breadcrumb-link"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BBreadcrumb: _breadcrumb.default,
  BBreadcrumbItem: _breadcrumbItem.default,
  BBreadcrumbLink: _breadcrumbLink.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/breadcrumb/index.js
// module id = 465
// module chunks = 7